module.exports = __webpack_public_path__ + "static/media/banner.ea38f4c6.png";